import React from "react";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";
function getItemIndex(index, { pageIndex, itemsPerPage }) {
    let itemIndex = index + 1;
    if (pageIndex != null && itemsPerPage != null) {
        itemIndex += pageIndex * itemsPerPage;
    }
    return itemIndex;
}
const Table = (props) => (<div className={classnames("scrollBox", props.className)}>
		<div className="scrollBox-inner">
			<table className="tableList mix-tableList_hOverflow" aria-describedby={props.srLabelPlural}>
				<thead>
					<tr className="tableListRow tableListRow-hdg">
						{props.columns.map(({ header }) => (<th key={header.id} className="tableListRow-list-col mix-tableListRow-list-col_hdg" scope="col">
								<FormattedMessage {...header}/>
							</th>))}
					</tr>
				</thead>
				<tbody>
					{props.items.map((item, index) => {
    const itemIndex = getItemIndex(index, props);
    return (<tr key={props.getKey == null ? itemIndex : props.getKey(item)} aria-describedby={`${props.srLabel} ${itemIndex}`} aria-rowindex={itemIndex} className="tableListRow">
								{props.columns.map(({ header, value, centerFirstColumn }, colIndex) => {
        let Cell = "td";
        let scope;
        let style;
        if (colIndex === 0) {
            Cell = "th";
            scope = "row";
            if (centerFirstColumn) {
                style = { textAlign: "center" };
            }
        }
        return (<Cell key={header.id} className="tableListRow-list-col" scope={scope} style={style}>
											{value(item)}
										</Cell>);
    })}
							</tr>);
})}
				</tbody>
			</table>
		</div>
	</div>);
export default Table;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/Table/Table.tsx